import { PrimaryCareTableColumnKeys } from "../enums/primaryCareTableDetails";

export const shouldNavigateToInsuranceDetails = (rowData: any): boolean => {
  const routeBadge = rowData?.[PrimaryCareTableColumnKeys.ROUTE];
  const routeVia =
    typeof routeBadge === "object" ? routeBadge?.text : routeBadge;
  return routeVia?.toUpperCase() === "CMM";
};
